import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IProFormaWizardStep } from '../types';

interface IProFormaWizardStepParams {
    orgId: string;
    proFormaId: string;
    stepNumber: number;
}

const getProFormaWizardStep = async ({ orgId, proFormaId, stepNumber }: IProFormaWizardStepParams): Promise<IProFormaWizardStep> => {
    const url = `${API_ENDPOINTS.PRO_FORMA_WIZARD_STEP(orgId, proFormaId, stepNumber)}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const useGetProFormaWizardStep = (orgId: string, proFormaId: string, stepNumber: number, options?: any) => useQuery<IProFormaWizardStep>({
    queryKey: ['ProFormaWizardStep', orgId, proFormaId, stepNumber],
    queryFn: () => getProFormaWizardStep({ orgId, proFormaId, stepNumber }),
    ...options,
});
